import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { slugToMerchantId } from '@/utils/util';
import { GetMerchantTimezoneQuery } from '@/gql/graphql';

const GET_MERCHANT_TIMEZONE = gql`
  query GetMerchantTimezone($merchantId: ID!) {
    getMerchantTimezone(merchantId: $merchantId)
  }
`;

export function useMerchantTimezone() {
  const { slug } = useParams<{ slug: string }>();
  const merchantId = slug ? slugToMerchantId(slug) : '';

  const { data, loading, error } = useQuery<GetMerchantTimezoneQuery>(GET_MERCHANT_TIMEZONE, {
    variables: { merchantId },
    skip: !merchantId
  });

  return {
    timezone: data?.getMerchantTimezone ?? 'UTC',
    loading,
    error
  };
}
